module.exports = __webpack_public_path__ + "img/dink-dining-1.5de0f0d1.jpeg";